(function () {
  'use strict';
  var form = document.getElementById('nqCartForm');
  if (!form || form.dataset.nqBound === '1') return;
  form.dataset.nqBound = '1';

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function () {
      window.location.reload();
    });
  }

  form.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nq-cart-qty], [data-nq-cart-remove]');
    if (!btn) return;
    e.preventDefault();

    if (btn.hasAttribute('data-nq-cart-remove')) {
      var line = btn.closest('.nq-cart-page__line');
      if (line) {
        line.style.opacity = '0.4';
        line.style.pointerEvents = 'none';
      }
      changeLine(btn.getAttribute('data-nq-cart-remove'), 0);
      return;
    }

    var key = btn.getAttribute('data-nq-cart-qty');
    var delta = parseInt(btn.getAttribute('data-delta'), 10);
    var input = form.querySelector('[data-nq-cart-input="' + key + '"]');
    var current = input ? parseInt(input.value, 10) : 1;
    if (isNaN(current)) current = 1;
    var next = Math.max(0, current + delta);
    if (input) input.value = String(next);
    var lineEl = btn.closest('.nq-cart-page__line');
    if (next === 0 && lineEl) {
      lineEl.style.opacity = '0.4';
      lineEl.style.pointerEvents = 'none';
    }
    changeLine(key, next);
  });
})();
